import { render, staticRenderFns } from "./TableInput.vue?vue&type=template&id=2531ba32&scoped=true&"
import script from "./TableInput.vue?vue&type=script&lang=js&"
export * from "./TableInput.vue?vue&type=script&lang=js&"
import style0 from "./TableInput.vue?vue&type=style&index=0&id=2531ba32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2531ba32",
  null
  
)

export default component.exports